module.exports = __webpack_public_path__ + "img/mining_full.aa3dbd99.png";